import React from 'react';
import { ContainerStyled } from './style';
import { Menu, Footer } from '@fundacao/shared-components/esm/ie';

interface MainLayoutProps {
  theme?: string;
}

const MainLayout: React.FC<MainLayoutProps> = (props) => {

  return (
    <ContainerStyled theme={props.theme}>
      <Menu />
      <div className="main-container">{props.children}</div>
      <Footer />
    </ContainerStyled>
  );
};

export default MainLayout;
